// extracted by mini-css-extract-plugin
export default {"productName":"styles__productName__NAibf"};